<template>
  <div>
    <div v-for="(group, index) in rightsGroups" :key="group.title">
      <div>
        <div class="accordion-item accordionForm">
          <a href="#" class="item-content item-link" @click="rotateChevron($event)">
            <div class="item-inner">
              <div class="form-group row justify-content-start styleGeneral">
                <div class="item-title createInvoiceBand col-sm-auto">
                  {{ $t(group.title) }}
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
              </div>
            </div>
          </a>

          <div class="accordion-item-content">
            <div class="form-group col-sm-12" v-for="line in group.lines" :key="getLineKey(line)">
              <div v-if="line.label">
                <label>{{ $t(line.label) }}</label>
                <input type="checkbox" class="pull-right"
                :disabled="isDisabled(getRightLabel(group.title, line.label))"
                :checked="isChecked(getRightLabel(group.title, line.label))"
                @change="rightChange(getRightLabel(group.title, line.label))">
                </input>
              </div>
              <div v-else>
                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                    <div class="item-inner">
                      <div class="form-group row justify-content-start styleGeneral">
                        <div class="item-title createInvoiceBand col-sm-auto">
                          {{ $t(line.title) }}
                          <i class="f7-icons formChevron">chevron_right</i>
                        </div>
                      </div>
                    </div>
                  </a>

                  <div v-for="groupLine in line.lines" :key="line.label" class="accordion-item-content">
                    <div class="form-group col-sm-12 pl-0 pr-0">
                      <label>{{ $t(groupLine.label) }}</label>
                      <input type="checkbox" class="pull-right"
                      :disabled="isDisabled(getRightLabel(group.title, line.title, groupLine.label))"
                      :checked="isChecked(getRightLabel(group.title, line.title, groupLine.label))"
                      @change="rightChange(getRightLabel(group.title, line.title, groupLine.label))">
                      </input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr v-if="(index + 1) != rightsGroups.length">
      </div>
    </div>
  </div>
</template>

<script>

import rightsData from '@/components/rights/data/rightsData.json'

import rightsMatchLabel from '@/components/rights/data/rightsMatchLabel.json'

export default {
  name: 'rightsList',
  props: {
    userRights: {
      type: Object,
      default: () => ({})
    },
    isNewProfile: {
      type: Boolean
    },
    forceDisable: {
      type: Boolean,
      default: false
    },
    isMyRightsPage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      rightsGroups: []
    }
  },
  watch: {
    userRights: function (newVar, oldVar) {
      this.userRights = newVar
    }
  },
  created () {
    this.rightsGroups = rightsData.groups
  },
  mounted () {
    if (!this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.$$('.accordionForm').addClass('accordion-item-expanded')
      this.$$('.formChevron').transform('rotate(90deg)')
    }
  },
  methods: {
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    getRightLabel (title, label, subLabel = '') {
      if (!subLabel) {
        return rightsMatchLabel[title + ':' + label]
      }
      return rightsMatchLabel[title + ':' + label + ':' + subLabel]
    },
    getLineKey (line) {
      return line.label ? line.label : line.title
    },
    // true : admin
    // false : company account
    isAdmin: function () {
      return this.$engine.user.get().id === this.$engine.user.get().userAccountId
    },
    isRightPayable (rightLabel) {
      if (!rightLabel || !this.userRights || !this.userRights[rightLabel]) {
        return false
      }
      return this.userRights[rightLabel].payable === '1'
    },
    doesUserPossessRight (rightLabel) {
      if (!rightLabel) {
        return false
      }
      return this.$engine.user.get().rights[rightLabel] === '1'
    },
    canModify (rightLabel) {
      // sur la page Mes Droits
      if (this.isMyRightsPage) {
        if (this.isAdmin() && !this.isRightPayable(rightLabel)) {
          return true
        }
      } else { // page profils de droits
        // user is giving rights, he must possess them in order to modify
        if (this.doesUserPossessRight(rightLabel)) {
          // need the creation / edit right
          if (this.isNewProfile) {
            return this.$engine.user.get().rights['rights_profile_creer'] === '1'
          } else {
            return this.$engine.user.get().rights['rights_profile_modifier'] === '1'
          }
        }
      }
      return false
    },
    isDisabled (rightLabel) {
      let result = !this.canModify(rightLabel)
      return result
    },
    rightChange (right) {
      if (!this.userRights) {
        this.userRights = {}
      }
      if (!this.userRights[right]) {
        this.userRights[right] = {}
        this.userRights[right].state = '1'
        return
      }
      this.userRights[right].state = this.userRights[right].state === '1' ? '0' : '1'
    },
    isChecked (right) {
      if (this.userRights && this.userRights[right]) {
        return this.userRights[right].state === '1'
      }
      return false
    }
  }
}
</script>
<style>
.styleGeneral:hover {
  text-decoration: underline;
  text-decoration-color: #51a45c;
}
</style>



// WEBPACK FOOTER //
// rightsList.vue?7c297da2